import { get, post } from "@/plugins/axios.js";

const baseApi = process.env.VUE_APP_BASE_API;
const dataApi = process.env.VUE_APP_DATA;
const fwClient = process.env.VUE_APP_FW_CLIENT;
const gifsApi = process.env.VUE_APP_GFS;
const fcdataApi = process.env.VUE_APP_FCDATA;
const pyApi = process.env.VUE_APP_PYAPI;
const apiData = {
  /**
   * 获取单位信息
   * @param {String} unitName 单位名称
   * @returns
   */
  getUnitInfo(unitName) {
    return get(`${fwClient}/login/${unitName}/begin`);
  },
  /**
   * 获取验证码
   * @returns
   */
  getVerCode() {
    return get(`${fwClient}/login/kaptchaImage`);
  },
  /**
   * 验证登录
   * @param {object} option
   */
  checkLogin(option) {
    // return post(`${baseApi}/login/checkLogin`, option);
    return post(`${fwClient}/login/checkLogin`, option);
  },
  /**
   * 退出登录
   */
  logout(token) {
    return post(`${fwClient}/login/loginOut`, { token });
  },
  /**
   * 获取栏目
   * @param {Object} option
   */
  listColumn(unitid) {
    return get(`${fwClient}/column/unitColumn/${unitid}`);
  },
  /**
   * 获取单位对象列表
   * @param {Object} option
   */
  unitObjs(id) {
    return get(`${fwClient}/unit-obj/unitObjs/${id}`);
  },
  /**
   * 获取管理单位对象列表
   * @param {Object} option
   */
  multiUnitObjs(unitids) {
    return get(`${fwClient}/unit-obj/multiUnitObjs/${unitids}`);
  },
  /**
   * 天气实况
   * @param {String} option
   */
  giftLive(option) {
    return get(`${fwClient}/giftLive/${option}.json`);
  },
  shuiwenStationSlideData(obtid) {
    return get(`${fwClient}/obj-live/shuiwenSlide/${obtid}`);
  },
  /**
   * 滑动小时实况数据
   * @param {Object} option
   */
  sildeLive(objid, size, type) {
    return get(`${fwClient}/obj-live/slideLive/${objid}/${size}/${type}`);
  },
  queryStatisLiveData(unitid, stime, etime) {
    return get(`${fwClient}/obj-live/queryStatisLiveData/${unitid}/${stime}/${etime}`);
  },
  querySlideLiveByZjz(staid, size) {
    return get(`${fwClient}/obj-live/slideLiveByZjz/${staid}/${size}`);
  },
  /**
   * gift预报
   * @param {Object} option
   */
  giftData(lat, lon) {
    return get(`${dataApi}/giftDailyCache/giftDaily${lat}_${lon}.json`);
  },

  /**
   * 正在生效的区县预警信号
   * @param {Object} option
   */
  countyAlarm(option) {
    return get(`${dataApi}/alarm/countyAlarm.json`, option);
  },
  townAlarm(option) {
    return get(`${dataApi}/alarm/townAlarm.json`, option);
  },
  /**
   * 预警信号查询
   * @param {Object} option
   */
  queryAlarmForCounty(option) {
    return post(`${fwClient}/alarm/queryAlarmForCounty`, option);
  },
  /**
   * 短临风险
   * @param {String} objid
   */
  riskFore(objid) {
    return get(`${fwClient}/risk/riskFore/${objid}`);
  },
  /**
   * 风险预测
   * @param {String} objid
   */
  riskShort(objid) {
    return get(`${fwClient}/risk/riskShort/${objid}`);
  },
  /**
   * 指数数据
   * @param objid
   * @returns {Promise | Promise<unknown>}
   */
  indexNumber(objid) {
    // const url = `${dataApi}/index/objIndex${objid}.json`;
    const url = `${fwClient}/index/select/${objid}`;
    return get(url);
  },
  /**
   * 适宜度数据
   * @param objid
   * @returns {Promise | Promise<unknown>}
   */
  suitabilityNumber(objid) {
    // const url = `${dataApi}/suitability/objSuitability${objid}.json`;
    const url = `${fwClient}/suitability/select/${objid}`;
    return get(url);
  },
  /**
   * 即时风险
   * @param {String} unitid
   */
  websktfw(unitid) {
    return post(`${fwClient}/websktfw/${unitid}`);
  },
  /**
   * 闪电查询
   * @param {String} option
   */
  queryLightningData(objid, stime, etime) {
    return get(`${fwClient}/lightning/queryLightningData/${objid}/${stime}/${etime}`);
  },
  /**
   * 当年所有台风路径
   * @param {String} option
   */
  queryAllYearTyphoon(year) {
    return get(`${dataApi}/typhoon/${year}/index.json`);
  },
  /**
   * 台风路径节点
   * @param {String} option
   */
  queryTyphoonPoints(year, tid) {
    return get(`${dataApi}/typhoon/${year}/${tid}.json`);
  },
  /**
   * 天气专报查询
   * @param {String} option
   */
  queryZhunagBao(option) {
    return post(`${fwClient}/data/zhuanBaoList`, option);
  },
  /**
   * 天气提醒查询
   * @param {String} option
   */
  queryTxMsg(option) {
    return get(`${fwClient}/tx-msg/queryTxMsg?unitid=${option.unitid}&stime=${option.stime}&etime=${option.etime}&keyword=${option.keyword}&page=${option.page}&pagesize=${option.pagesize}`);
  },
  /**
   * 天气提醒查询
   * @param {String} option
   */
  queryRiskHistory(option) {
    return get(`${fwClient}/risk/riskHistory?unitid=${option.unitid}&objid=${option.objid}&stime=${option.stime}&etime=${option.etime}&keyword=${option.keyword}&page=${option.page}&pagesize=${option.pagesize}`);
  },
  /**
   * 实况查询查询统计
   * @param {String} option
   */
  queryLiveData(option) {
    return post(`${fwClient}/data/queryLiveData`, option);
  },
  /**
   * 查询实时风险排名
   * @param {String} option
   */
  nowRiskSort(unitid) {
    return get(`${fwClient}/risk/nowRiskSort/${unitid}`);
  },
  /**
   * 栏目排序
   * @param {String} option
   */
  columnSortt(option) {
    return post(`${fwClient}/column/columnSort`, option);
  },
  /**
   * 过去小时雨量
   * @param {String} option
   */
  slideLive(option) {
    return post(`${fwClient}/data/slideLive`, option);
  },
  /**
   *单位对象是否重要
   * @param {String} option
   */
  updateObjZy(id, iszy) {
    return post(`${fwClient}/unit-obj/updateObjZy/${id}/${iszy}`);
  },
  /**
   *当前生效的风险比例
   * @param {String} option
   */
  nowRiskCount(unitid) {
    return get(`${fwClient}/statistic/nowRiskCount/${unitid}`);
  },
  /**
   *按单位查询对象
   * @param {String} option
   */
  objStatusByUnit(unitid) {
    return get(`${fwClient}/statistic/objStatusByUnit/${unitid}`);
  },
  /**
   *风险提醒按日，周，月，年次数统计
   * @param {String} option
   */
  riskHisCount(unitid) {
    return get(`${fwClient}/statistic/riskHisCount/${unitid}`);
  },
  /**
   *天气提醒提醒按日，周，月，年次数统计
   * @param {String} option
   */
  txMsgCount(unitid) {
    return get(`${fwClient}/statistic/txMsgCount/${unitid}`);
  },
  /**
   *专报提醒按日，周，月，年次数统计
   * @param {String} option
   */
  zhuanBaoCount(option) {
    return post(`${fwClient}/statistic/zhuanBaoCount`, option);
  },
  /**
   *晴雨表
   * @param {String} option
   */
  selectQyTable(objid, year) {
    return get(`${fwClient}/qy-table/selectQyTable/${objid}/${year}`);
  },
  /**
   *获取自动站雨量数据
   * @param {String} option
   */
  getObtData() {
    return get("resoures/obtData.json");
  },
  /**
   *获取实况排名
   * @param {String} option
   */
  getObjRainSort(unitid) {
    return get(`${fwClient}/obj-live/objRainSort/${unitid}`);
  },
  /**
   *获取EC模式预报
   * @param {String} option
   */
  getecDaily(lat, lon) {
    return get(`${dataApi}/ecDailyCache/ecDaily${lat}_${lon}.json`);
  },
  /**
   *获取提醒消息
   * @param {String} option
   */
  newTxMsgShiWu(unitid) {
    return get(`${fwClient}/statistic/newTxMsgShiWu/${unitid}`);
  },
  /**
   *获取雨晴通报最新内容
   * @param {String} option
   */
  newestYqtbCont(unitid) {
    return get(`${fwClient}/yqtb/newestYqtbCont/${unitid}`);
  },
  /**
   *获取雨晴通报时间
   * @param {String} option
   */
  newestYqtbTime() {
    return get(`${dataApi}/rainPic/dataTime.json`);
  },
  /**
   *获取雷电数据
   * @param {String} option
   */
  getThunder(etime) {
    return get(`${fwClient}/lightning/slideLightning/${etime}`);
  },
  /**
   *获取风球信号
   * @param {String} option
   */
  getWindBball() {
    return get(`${fwClient}/windBall.json`);
  },
  /**
   *栏目的状态（有效无效）
   * @param {String} option
   */
  changeColunmStatus(option) {
    return post(`${fwClient}/column/invalidcolumn`, option);
  },
  /**
   *栏目的状态（有效无效）
   * @param {String} option
   */
  changeCardStatus(option) {
    return post(`${fwClient}/column/updateCard`, option);
  },
  /**
   *雨晴内容
   * @param {String} option
   */
  getYuqiData(unitid) {
    return get(`${fwClient}/yqtb/newestYqtbTb/${unitid}`);
  },
  /**
   *每月天气
   * @param {String} option
   */
  getMrtqData(id) {
    return get(`${fwClient}/obj-live/objYearDayLive/${id}`);
  },
  /**
   *七天预报
   * @param {String} option
   */
  getSevenDay(lat, lon) {
    return get(`${dataApi}/giftDailyCache/giftDaily${lat}_${lon}.json`);
  },
  /**
   *雨量图片数据
   * @param {String} option
   */
  rainImage() {
    return get(`${dataApi}/rainPic/rainPicIndex.json`);
  },

  // /**
  //  *风场
  //  * @param {String} option
  //  */
  // queryWindData () {
  //   return get('/gfs//fcdata/202304/27/02/012.json?v=1682584934120')
  // },
  /**
   *单个天气实况
   * @param {String} option
   */
  queryWheatherLiveData(objid) {
    // return get(`${dataApi}/objLiveData.json`);
    return get(`${fwClient}/obj-live/objdata/${objid}`);
  },
  /**
   *全部单位点天气实况
   * @param {String} option
   */
  queryWheatherLiveDataByUnitid(unitid) {
    return get(`${fwClient}/obj-live/objLiveByUnitid/${unitid}`);
  },

  /**
   *获取七天预报
   * @param {String} option
   */
  querySevenDayData() {
    return get(`${fwClient}/sevenDay/qxtForecast`);
  },
  getGeoJson(url) {
    return get(`${dataApi}${url}`);
  },
  getUnitPointData(unitId) {
    return get(`${fwClient}/obj-live/pointLiveData/${unitId}`);
  },
  getZjStationData(unitId) {
    return get(`${fwClient}/obj-live/zjzLiveData/${unitId}`);
  },
  getStpData(unitId) {
    // return get(`${dataApi}/stp/obj${unitId}.json`);
    return get(`${fwClient}/stp/stpByObj/${unitId}`);
  },
  /**
   *获取风场时间线
   * @param {String} option
   */
  queryWindTimeData() {
    return get(`${gifsApi}/gfs/time_fc.json`);
  },
  getUnitBorderImg(name) {
    return `${dataApi}/unitbac/${name}`;
  },
  querySzTfWindTimeData() {
    // return get(`https://tf.121.com.cn/weather/ecwindflow/windtime925.txt?${new Date().getTime()}`)
    return get(`${fcdataApi}/windtime925.txt?${new Date().getTime()}`);
  },
  querySzTfWindData(time, leadtime) {
    // return get(`https://tf.121.com.cn/weather/ecwindflow/windtime925.txt?${new Date().getTime()}`)
    return get(`${fcdataApi}/${time}/${time}_uv_925_${leadtime}.json`);
  },
  queryFsTfWindTimeData() {
    // return get(`https://tf.121.com.cn/weather/ecwindflow/windtime925.txt?${new Date().getTime()}`)
    return get(`${fcdataApi}/latestTime.json`);
  },
  queryFsTfWindData(time, leadtime) {
    // return get(`https://tf.121.com.cn/weather/ecwindflow/windtime925.txt?${new Date().getTime()}`)
    return get(`${fcdataApi}/${time}/${time}_uv_925_${leadtime}.json`);
  },
  /**
   *获取风场数据
   * @param {String} option
   */
  queryWindData(time) {
    return get(`${gifsApi}/gfs/fcdata/${time}`);
  },

  /**
   *相控阵雷达数据
   * @param {String} option
   */
  queryPhasedRadarData(time) {
    return get(`${dataApi}/AESApic/CR/index.json`);
  },

  /**
   *内涝预警数据
   * @param {String} option
   */
  queryWaterLiveGradeData(time) {
    return get(`${dataApi}/neilao/WaterLiveGrade.json`);
    // return get(`${dataApi}/neilao/WaterLiveGrade_test.json`)
  },

  /**
   *内涝雨量阈值数据
   * @param {String} option
   */
  queryWaterPointStandardData() {
    return get(`${dataApi}/neilao/WaterPointStandard.json`);
  },
  // 紫外线数据
  queryUltravioletRaysData() {
    return get(`${fwClient}/ul/select`);
  },

  /**
   *获取企业道路结冰数据
   * @param {String} option
   */
  queryNewestRoadicingData(unitid) {
    return get(`${fwClient}/roadicing/newest/${unitid}`);
  },
  /**
   * 查询资讯列表
   * @param option
   * @returns {Promise | Promise<unknown>}
   */
  queryArticleList(unitid, page, pageSize) {
    return get(`${fwClient}/article/selectArticleByPage/${unitid}/${page}/${pageSize}`);
  },
  queryArticleDetail(id) {
    return get(`${fwClient}/article/selectArticleById/${id}`);
  },
  /**
   *获取自动站实况数据
   * @param {String} option
   */
  // queryegObtLiveData (option) {
  //   return get(`${dataApi}/egObtLive.json`, option)
  // }
  /**
   * 获取单位实况站点数据 可根据时间查询
   */
  queryPointLiveData(unitid, datetime) {
    return get(`${fwClient}/obj-live/queryPointLiveData/${unitid}/${datetime}`);
  },
  /**
   * 获取统计要素(雨量/风力)报表
   */
  searchRainConent(ele, unitid, stime, etime, town) {
    return get(
      `${pyApi}/search_${ele}?unitid=${unitid}&stime=${stime}&etime=${etime}&town=${town}`,
    );
  },
  /**
   * 获取行业报告
   */
  queryHyReport(unitid) {
    return get(`${fwClient}/hy-report/gainHyRpeportList/${unitid}`);
  },
  /**
   * 空气质量
   */
  queryAirQuality() {
    return get(`${fwClient}/air/select`);
  },
  /**
   * 精细化雨量评估
   */
  queryRefindRain(lat) {
    // return get(`${dataApi}/qpfCache/${lat}.json`);
    return get(`${fwClient}/qpf/${lat}`);
  },
  /**
   * 旅游气候舒适度
   */
  querycountyOccupant() {
    return get(`${dataApi}/countyOccupant.json`);
  },
  /**
   * 地铁预警预报
   */
  queryMetroAlertForecast() {
    return get(`${fwClient}/alarm/subway`);
  },
  /**
   * 地铁预警预报确认
   */
  queryMetroAlertAck() {
    return get(`${fwClient}/alarm/subway/ack`);
  },
  /**
   * 查询实况阈值告警
   */
  queryRealTimeAlarm() {
    return get(`${fwClient}/tx-msg/subway/warn`);
  },
  /**
   * 确认实况阈值告警
   */
  queryRealTimeAlarmAck(id) {
    return get(`${fwClient}/tx-msg/subway/warn/ack?id=${id}`);
  },
};
export default apiData;
